// extracted by mini-css-extract-plugin
module.exports = {"TitledContent":"styles_TitledContent__m5Dko","TitledContentTitle":"styles_TitledContentTitle__KG_cn","TitledContentContent":"styles_TitledContentContent__3SI4C"};